module.exports = __webpack_public_path__ + "static/media/Bussiness.5aaeb11b.svg";